/**
 * NOLAS 2026, (c) Mikaël FOURNY.
 * src/i18n/fr.personne.ts
 *
 * Rôle :
 *   Sous-catalogue de la fiche complète d'une personne (écran
 *   `/admin/person/:id`). Fusionné dans `messagesFr` par `i18n/fr.ts`.
 *   Uniquement des clés NEUVES, aucune redéfinition du noyau : une clé, une
 *   source.
 *
 * Mikael - chef de projet - 2026-09-20
 */
export const messagesPersonneFr: Record<string, string> = {
  'adminNav.person': 'Fiche complète',

  'person.retour': 'Comptes',
  'person.nav': 'Sections de la fiche',
  'person.chargement': 'Chargement de la fiche…',
  'person.erreur.id': 'Identifiant de personne invalide.',
  'person.erreur.chargement':
    'Impossible de charger cette fiche. Vérifiez votre accès à la section « Fiche complète », ou réessayez.',
  'person.vide': 'non renseigné',
  'person.oui': 'oui',
  'person.non': 'non',
  'person.mineur': 'mineur',
  'person.indisponible':
    'Une partie des informations n’a pas pu être lue. La fiche est incomplète, et le dit.',
  'person.fiche.publiee': 'fiche publiée',
  'person.fiche.brouillon': 'fiche en brouillon',

  'person.action.ecrire': 'Écrire',
  'person.action.appeler': 'Appeler',
  'person.action.fiche': 'Fiche complète',
  'person.action.ficheAria': 'Ouvrir la fiche complète de {name}',

  'person.tuile.recus': 'personnes rencontrées',
  'person.tuile.passages': 'stands visités',
  'person.tuile.ateliers': '{lexWorkshopPlural} suivis',
  'person.tuile.animes': '{lexWorkshopPlural} animés',
  'person.tuile.candidaturesRecues': 'candidatures reçues',
  'person.tuile.candidatures': 'candidatures envoyées',
  'person.tuile.offres': 'offres publiées',

  'person.section.identite': 'Identité',
  'person.section.mineur': 'Personne mineure',
  'person.section.consentements': 'Consentements',
  'person.section.entreprise': 'Entreprise',
  'person.section.offres': 'Offres d’emploi',
  'person.section.animes': '{lexWorkshopPluralCap} animés',
  'person.section.ateliers': '{lexWorkshopPluralCap} suivis',
  'person.section.recus': 'Personnes rencontrées',
  'person.section.passages': 'Stands visités',
  'person.section.cv': 'CV et candidatures',
  'person.section.candidatures': 'Candidatures reçues',
  'person.section.favoris': 'Favoris et avis',
  'person.section.groupe': 'Groupe et transport',
  'person.section.reponses': 'Questionnaires',
  'person.section.acces': 'Accès au back-office',
  'person.section.journal': 'Journal',
  'person.section.indisponible': 'Informations indisponibles',
};
